import Utils from '../../services/Utils'
import { FormErrorStrategy } from '../config/ErrorHandler'
import { GApi, defineCancelApiObject, defaultHeaders } from '../config/GApi'

const CostCenterApi = {
  getList: async function (cancel = false) {
    const response = await GApi.request({
      url: '/core/cost-center',
      method: 'GET',
      headers: defaultHeaders(),
      signal: cancel
        ? cancelApiObject[this.getList.name].handleRequestCancellation().signal
        : undefined,
    })

    Utils.ensureJson(response)

    return response.data
  },
  create: async function (post, cancel = false) {
    const response = await GApi.request({
      url: '/core/cost-center',
      method: 'POST',
      headers: defaultHeaders(),
      data: post,
      errorStrategy: FormErrorStrategy,
      signal: cancel
        ? cancelApiObject[this.create.name].handleRequestCancellation().signal
        : undefined,
    })

    Utils.ensureJson(response)

    return response.data
  },
  update: async function (post, cancel = false) {
    const response = await GApi.request({
      url: '/core/cost-center/' + post.id,
      method: 'PUT',
      headers: defaultHeaders(),
      data: post,
      errorStrategy: FormErrorStrategy,
      signal: cancel
        ? cancelApiObject[this.update.name].handleRequestCancellation().signal
        : undefined,
    })

    Utils.ensureJson(response)

    return response.data
  },
  delete: async function (id, cancel = false) {
    const response = await GApi.request({
      url: '/core/cost-center/' + id,
      method: 'DELETE',
      headers: defaultHeaders(),
      signal: cancel
        ? cancelApiObject[this.delete.name].handleRequestCancellation().signal
        : undefined,
    })

    Utils.ensureJson(response)

    return response.data
  },
}

const cancelApiObject = defineCancelApiObject(CostCenterApi)

export default CostCenterApi
